<template>
  <div class="m-market-specifier">
    <div class="m-market-row">
      <div class="m-title" />
      <template v-for="(title, index) in marketTitles">
        <div
          :key="`${title}-${index}`"
          class="m-title"
        >
          {{ title }}
        </div>
      </template>
    </div>
    <template v-for="(market, index) in sortedMarkets">
      <Market1SpecifierItem
        v-if="market.outcomes"
        :key="index"
        :event="event"
        :market="market"
        :market-titles="marketTitles"
        class="m-market-row"
      />
    </template>
  </div>
</template>

<script>
/**
 * 一、将specifier拆出来
 * 规则描述：为了给用户更好的体验，将market中的specifier拆出来，odds单独占用selection选择框；
 * 要求：specifier可拆
 */
import Market1SpecifierItem from './Market1SpecifierItem.vue'

export default {
  name: 'Market1Specifier',
  components: {
    Market1SpecifierItem
  },
  props: {
    markets: {
      type: Array,
      default: () => []
    },
    event: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      marketTitles: []
    }
  },
  computed: {
    sortedMarkets() {
      const list = [...this.markets]
      if (!list[0]) return []

      if (list.length === 1) {
        return list
      }
      // 默认使用 specifiers 字典序, 数字从小到大
      list.sort((a, b) => this.getShowSpecifiers(a.specifiers) - this.getShowSpecifiers(b.specifiers))
      return list
    },
    checkIsActive() {
      let val = 0
      const { markets } = this
      if (Array.isArray(markets)) {
        if (markets.every((x) => +x.status === 2)) {
          val = 2
        } else if (markets.every((x) => +x.status === 3)) {
          val = 3
        } else if (markets.some((x) => +x.status === 0 || +x.status === 1)) {
          val = 0
        } else {
          val = 3
        }
      } else {
        val = markets.status
      }
      return val
    }
  },
  watch: {
    checkIsActive: {
      immediate: true,
      handler(val) {
        if (!this.markets[0] || !this.markets[0].marketTypeDesc) return false
        this._timer && clearTimeout(this._timer)
        const option = this.markets[0].marketTypeDesc.split('-')
        if (val !== 2) {
          this.$emit('checkDeactive', val !== 2, option)
          return false
        }
        this._timer = setTimeout(() => {
          this.$emit('checkDeactive', val !== 2, option)
          clearTimeout(this._timer)
        }, 5000)
      }
    }
  },
  created() {
    this.getMarketTitles()
  },
  methods: {
    getShowSpecifiers(specifiers) {
      return specifiers.split('=')[1]
    },
    getMarketTitles() {
      if (!this.markets[0] || !this.markets[0].outcomes) return
      const { groupName, title } = this.markets[0]
      const { map, order } = this.markets[0].outcomes
      // return order.map(id => map[id].description.replace(/\(.*\)/, ''))
      if (groupName && groupName === 'Double Chance') {
        this.marketTitles = title.split(',')
      } else {
        this.marketTitles = order.map((id) => map[id].description.split(/\s/)[0])
      }
    }
  }
}
</script>

<style lang="less">
.m-market-specifier {
  .m-market-row .m-outcome {
    padding: 0;
  }
}
</style>
